import React, { useEffect } from "react";
import { BrowserRouter as WithOutHash } from "react-router-dom";
import Routes from "../routes";
import { ModuleContextProvider } from "../context/Context";
import "../App.css";
import { DirtyProvider } from "../utils/DirtyContext";
import TutorialManager from "../modules/Tutorial/TutorialManager";
import useHydrateFilterState from "../utils/hooks/useHydrateFilterState";
import { useDispatch } from "react-redux";
import { fetchGeoStates } from "../Redux/geo/geoThunk";

function App() {
  useHydrateFilterState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchGeoStates());
  }, [dispatch]);

  return (
    <WithOutHash>
      <DirtyProvider>
        <ModuleContextProvider>
          <Routes />
          <TutorialManager />
          <canvas
            id="confetti-container"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              pointerEvents: "none",
              zIndex: 10005, // above most overlays
            }}
          />
        </ModuleContextProvider>
      </DirtyProvider>
    </WithOutHash>
  );
}

export default App;
